import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as Util from "../../services/global.service";
import { useFormik } from 'formik';
import { find } from 'lodash';
import * as yup from 'yup';

import Upload from '../../views/app/admin/import/UploadFiles'
import calibrationService from "../../services/calibration.service";

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { id, open, close, typeFiles } = props
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [dataCycle, setDataCycle] = React.useState([]);
  const [require, setRequire] = React.useState(true);
  const [dataTemplate, setDataTemplate] = React.useState([]);
  const [dataFiles, setDataFiles] = React.useState([]);
  const [fileName, setFileName] = React.useState('');

  const handleCloseDialog = (refresh = false) => {
    close(refresh);
  };
  const validationSchema = yup.object({
    templateType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    fileType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
  });
  const formik = useFormik({
    initialValues: {
      templateType: "",
      cycle: "",
      fileType: "xlsx",
      templateID: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
    },
  });


  const uploadFileSuccess = (dataFile) => {
    setRequire(false)
    setDataFiles(dataFile)
  }


  useEffect(() => {
    formik.setFieldValue("templateID", "")
  }, [dataTemplate])

  let setValFilter = (field, require_cycle, data) => {
    if (require_cycle !== "") {
      if (field === "templateType") {
        formik.setFieldValue("templateType", data)
        setRequire(require_cycle)
        if (require_cycle === false) {
          formik.setFieldValue("cycle", "")
          setDataTemplate([])
        }
      } else {
        formik.setFieldValue(field, data)

        if (field === "cycle") {
          let cycle = find(dataCycle, { id: data })
          if (cycle) {
            setDataTemplate(cycle.templates || [])
          }
          else setDataTemplate([])
        }
      }
    } else {
      formik.setFieldValue(field, data)
    }
  }

  const uploadfile = () => {
    if (dataFiles.length > 0) {
      let datas = new FormData();
      for (let index = 0; index <= dataFiles.length - 1; index++) {
        setFileName(dataFiles[index].name);
        datas.append("file", dataFiles[index]);
        datas.append("id", id);
      }


      calibrationService.uploadFiles(datas).then((rs) => {

        handleCloseDialog(true)

      }).catch((err) => {

      })
    }
  }

  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <DialogContent sx={{ padding: "0" }}>
        <Upload sendFiles={uploadFileSuccess} typeFiles={typeFiles} isDialog={true} onClear={() => { setRequire(true) }} ></Upload>
        <Box sx={{ justifyContent: "center", display: "flex" }}>
          <Box sx={{ display: "flex", width: "211px", justifyContent: "center" }}>
            <Button color="primary" variant="contained" fullWidth onClick={uploadfile} disabled={require} >
              <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="29px" fontWeight="500" color="#FFF">Save</Typography>
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default DefaultForm;
